/* ------------------------------------------------------------------
   Fast Printed Packaging - shared VAT/sale helper for JS-driven price
   updates. Ported from Parcelsend (Sept 2026 VAT rework).

   Keep VAT_RATE and LEGACY_VAT_GUARD in step with snippets/price.liquid
   and snippets/price-2.liquid.

   Used by sticky-atc-bar.js so it applies identical rules to the Liquid.
   Without it, that script overwrites the whole .f-price-item--sale span
   and destroys the "exc. VAT each" label.
   ------------------------------------------------------------------ */
window.FPPVAT = (function () {
  var VAT_RATE = 20;

  // Switched OFF on 30 Sep 2026 once the legacy VAT compare-at values were
  // cleared from all 1,611 live variants. While it was on, any compare-at
  // within a penny of price x VAT was ignored, which would now suppress a
  // genuine sale at those figures (e.g. price 10.00 with a was-price of
  // 12.00). Leave it false.
  var LEGACY_VAT_GUARD = false;

  function vatFactor() {
    return 1 + VAT_RATE / 100;
  }

  // price in minor units (pence). Matches Liquid's round-half-up.
  function incVat(price) {
    return Math.round(price * vatFactor());
  }

  // Mirrors the has_sale logic in snippets/price.liquid exactly.
  function isRealSale(price, compareAtPrice) {
    if (!compareAtPrice || compareAtPrice <= price) return false;
    if (LEGACY_VAT_GUARD && Math.abs(compareAtPrice - incVat(price)) <= 1) return false;
    return true;
  }

  function savingPct(price, compareAtPrice) {
    return Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
  }

  function money(cents) {
    return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
  }

  /**
   * Update a rendered .f-price block in place for a new variant, without
   * destroying the "exc. VAT each" / "inc. VAT each" labels.
   */
  function updatePriceBlock(priceWrapper, variant) {
    if (!priceWrapper || !variant) return;

    var price = variant.price;
    var compareAt = variant.compare_at_price;
    var priceInc = incVat(price);
    var hasSale = isRealSale(price, compareAt);

    // f-price--on-sale stays on unconditionally: it is what theme.css uses
    // to reveal the exc/inc block. f-price--real-sale means truly discounted.
    priceWrapper.classList.add('f-price--on-sale');
    priceWrapper.classList.toggle('f-price--real-sale', hasSale);
    priceWrapper.classList.toggle('f-price--sold-out', variant.available === false);

    var excEl = priceWrapper.querySelector('.excPrice');
    if (excEl) excEl.innerHTML = money(price);

    var incEl = priceWrapper.querySelector('.incPrice');
    if (incEl) incEl.innerHTML = money(priceInc);

    // Keep the data-price attributes in step - pricing-qty.js reads these.
    var items = priceWrapper.querySelectorAll('.f-price-item--sale');
    if (items.length > 0) items[0].setAttribute('data-price', money(price));
    if (items.length > 1) items[1].setAttribute('data-price', money(priceInc));

    var saleBlock = priceWrapper.querySelector('.f-price__sale');
    var wasRow = priceWrapper.querySelector('.f-price__was-row');

    if (hasSale) {
      if (!wasRow && saleBlock) {
        wasRow = document.createElement('div');
        wasRow.className = 'f-price__was-row';
        wasRow.innerHTML = '<span class="f-price__was"></span><span class="f-price__saving"></span>';
        saleBlock.appendChild(wasRow);
      }
      if (wasRow) {
        wasRow.style.display = '';
        var wasEl = wasRow.querySelector('.f-price__was');
        var saveEl = wasRow.querySelector('.f-price__saving');
        if (wasEl) wasEl.innerHTML = 'Was ' + money(compareAt);
        if (saveEl) saveEl.textContent = 'Save ' + savingPct(price, compareAt) + '%';
      }
    } else if (wasRow) {
      wasRow.style.display = 'none';
    }
  }

  return {
    VAT_RATE: VAT_RATE,
    incVat: incVat,
    isRealSale: isRealSale,
    savingPct: savingPct,
    money: money,
    updatePriceBlock: updatePriceBlock,
  };
})();